import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/theme.scss";
import { useTranslation } from "react-i18next";
import { Button, Grid, Typography, Input } from "@mui/material";
import { styled } from "@mui/material/styles";
import AdminTable from "./AdminTable";
import { useNavigate } from "react-router-dom";
import { ADMIN_USER_FORM, CLAIM_FORM } from "../../utils/constant";
import { fetchHealthFacilities, loadingUser } from "../../action";
import AdminFilter from "./AdminFIlter";
import { useConvention } from "../../hooks/useConvention";

function AdminTab() {
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [insureeCheck, setInsureeCheck] = useState(false);
  const [policyHolderId, setPolicyHolderId] = useState();
  const [insureeData, setInsureeData] = useState();
  const [filter, setFilter] = useState([]);
  const userData = useSelector((state) => state.profileReducer);
  const hanldeClaimScreen = () => {
    navigate(ADMIN_USER_FORM);
  };
  useEffect(() => {
    dispatch(loadingUser(token));
  }, []);

  const { isConventionnementActive } = useConvention()

  useEffect(() => {
    if (userData?.currentUserResponseData?.i_user?.health_facility_id) {
      dispatch(
        fetchHealthFacilities(
          userData?.currentUserResponseData?.i_user?.health_facility_id
        )
      );
    }
  }, [userData]);

  return (
    <Grid container>
      <Grid container display="flex" justifyContent="space-between">
        <Typography
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#000",
            marginLeft: "20px",
          }}
        >
          {" "}
          {t("adminManagement.title")}
        </Typography>
        <Grid style={{ marginRight: "20px" }}>
          <Button
            onClick={hanldeClaimScreen}
            variant="outlined"
            component="span"
            color="primary"
            disabled={!isConventionnementActive}
            style={{ marginLeft: ".5rem" }}
          >
            {t("adminManagement.create")}
          </Button>
        </Grid>
      </Grid>
      {policyHolderId}

      <AdminFilter
        policyHolderId={policyHolderId}
        setFilter={setFilter}
        filter={filter}
      />
      <AdminTable
        policyHolderId={policyHolderId}
        filter={filter}
        setInsureeData={setInsureeData}
        insureeCheck={insureeCheck}
      />
    </Grid>
  );
}

export default AdminTab;
